import Avatar from "react-avatar";
import axios from "axios";
import useCookie from "../hooks/useCookie";
import { useContext } from "react";
import { ColorContext } from "../context/ColorContext";
import { EntityManagementContext } from "../context/EntityManagementContext";

function StudentRow(props) {
    const csrftoken = useCookie("csrftoken");

    const {
        setMode,
        setEditingID,
        openPopup,
        students,
        setStudents
    } = useContext(EntityManagementContext);

    const { blue, white } = useContext(ColorContext);

    const headers = {
        "X-CSRFToken": csrftoken,
    };

    const editStudent = () => {
        setMode("Edit");
        setEditingID(props.id);
        openPopup(); // If page is narrow, open popup
    }

    const deleteStudent = (event) => {
        event.preventDefault();

        let deletionConfirmation = false;

        deletionConfirmation = window.confirm(
            `\nDelete ${props.name}?\nPress OK to confirm, or cancel this action.`
        );

        if (deletionConfirmation) {
            axios
                .delete(`/api/students/${props.id}/`, { headers })
                .then(() => {
                    let mutableStudents = students;
                    mutableStudents = mutableStudents.filter(student => student.id != props.id);
                    setStudents(mutableStudents);
                })
                .catch((error) => console.error(error));
        }
    }

    return (
        <>
            <td>
                <Avatar name={props.name} round={true} size="50" color={blue} fgColor={white} /> {/* Profile picture */}
                {props.name} {/* Name */}
            </td>
            <td>
                {props.email} {/* Email */}
            </td>
            <td>
                {props.age} {/* Age */}
            </td>
            <td> {/* Actions */}
                <button onClick={editStudent}>Edit</button> {/* Edit button */}
                <button onClick={deleteStudent}>Delete</button> {/* Delete button */}
            </td>
        </>
    );
}

export default StudentRow;